import Vue from 'vue'
import Router from 'vue-router'
import MainView from '@/components/MainView'
import TkBioListView from '@/components/TkBioListView'
import TkProfileView from '@/components/TkProfileView'
import TkPictGridView from '@/components/TkPictGridView'
import TkStoriesView from '@/components/TkStoriesView'
import TkVideosView from '@/components/TkVideosView'
import TkAboutView from '@/components/TkAboutView'
import TkWebDev23 from '@/components/TkWebDev23'
import TkTechnical from '@/components/TkTechnical'
import TkContacts from '@/components/TkContacts'
import NotFound404 from '@/components/NotFound404'
import Stage1 from '@/components/Stage1'
import Stage2 from '@/components/Stage2'
import Test from '@/components/Test'

Vue.use(Router)

export default new Router({
  mode: 'history',
  root: '/src',
  routes: [
    {
      path: '*',
      component: NotFound404
    },
    {
      path: '/test',
      name: 'Test',
      component: Test
    },
    {
      path: '/stage1',
      name: 'Stage1',
      component: Stage1
    },
    {
      path: '/stage2/:tkid',
      name: 'Stage2',
      component: Stage2,
      beforeEnter: (to, from, next) => {
        localStorage.setItem('tkid', to.params.tkid)
        next();
      }
    },
    {
      path: '/',
      name: 'MainView',
      component: MainView
    },
    {
      path: '/tkbios',
      name: 'TkBioListView',
      component: TkBioListView,
      props: true
    },
    {
      path: '/tkprofile/:tkid',
      name: 'TkProfileView',
      component: TkProfileView,
      props: true,
    },
    {
      path: '/pgrid/:tkid',
      name: 'TkPictGridView',
      component: TkPictGridView,
      props: true
    },
    {
      path: '/stories/:tkid',
      name: 'TkStoriesView',
      component: TkStoriesView,
      props: true
    },
    {
      path: '/videos/:tkid',
      name: 'TkVideosView',
      component: TkVideosView,
      props: true
    },
    {
      path: '/about',
      name: 'TkAboutView',
      component: TkAboutView,
      props: true
    },
    {
      path: '/tkwebdev23',
      name: 'TkWebDev23',
      component: TkWebDev23,
      props: true
    },
    {
      path: '/tktech',
      name: 'TkTechnical',
      component: TkTechnical,
      props: true
    },
    {
      path: '/tkcontacts',
      name: 'TkContacts',
      component: TkContacts,
      props: true
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js